import times from 'lodash/times';
import React, { FunctionComponent } from 'react';

import styles from './opinion.module.scss';

export interface IOpinionProps {
  title: string;
  description: string;
  rating: number;
}

export const Opinion: FunctionComponent<IOpinionProps> = props => {
  const { title, description, rating } = props;

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h2 className={styles.title}>{title}</h2>
        <div className={styles.description}>{description}</div>
        <p className={styles.rating}>
          <span className={styles.number}>{rating.toFixed(1)}</span>
          {times(rating, i => (
            <span className={styles.star} key={i}>
              &#9733;
            </span>
          ))}
        </p>
      </div>
    </div>
  );
};
